import { useTranslation } from 'react-i18next';
import { mockSavedProducts } from '@/mocks/dashboard';
import DashboardSavedProducts from './components/DashboardSavedProducts';

export default function FavoritesPage() {
  const { t } = useTranslation('dashboard');
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl md:text-2xl font-bold text-ink-700">{t('dashboard.savedProducts.title')}</h1>
        <p className="text-sm text-ink-300 mt-1">Products you have saved</p>
      </div>
      <DashboardSavedProducts products={mockSavedProducts} />
    </div>
  );
}